<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card>
          <v-card-title class="textoUser">UPLOAD DE PLANILHA</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-file-input
                  label="Selecione o arquivo para importar"
                  outlined
                  dense
                  v-model="file"
                  accept=".xlsx, .ods, .xls, .csv"
                  hide-details
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row v-if="file">
              <v-col cols="12" sm="10" md="10" lg="10">
                <XlsxRead :file="file">
                  <XlsxSheets>
                    <template #default="{sheets}">
                      <v-select
                        v-if="sheets.toString()"
                        v-model="planilhaSelecionada"
                        :items="sheets"
                        outlined
                        dense
                        label="Escolha a tabela"
                        hide-details
                      ></v-select>
                    </template>
                  </XlsxSheets>
                  <XlsxJson :sheet="planilhaSelecionada" v-show="false">
                    <template #default="{collection}">
                      <span v-if="collection">{{ carregaDados(collection) }}</span>
                    </template>
                  </XlsxJson>
                </XlsxRead>
              </v-col>
              <v-col sm="2" md="2" lg="2">
                <v-btn text block tile color="#00253E" :disabled="!planilhaSelecionada" @click="enviaDados">
                  <v-icon left dark>upload</v-icon>Enviar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <br>
        <v-card>
        </v-card>
      </v-col>
    </v-row>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#60b5b1" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import XlsxRead from "../../node_modules/vue-xlsx/dist/components/XlsxRead";
  import XlsxJson from "../../node_modules/vue-xlsx/dist/components/XlsxJson";
  import XlsxSheets from "../../node_modules/vue-xlsx/dist/components/XlsxSheets";
  export default {
    components: { Snackbar, Loading, XlsxRead, XlsxJson, XlsxSheets },
    data: () => ({
      isLoading: false,
      fullPage: true,
      planilhaParaJson: null,
      planilhaSelecionada: null,
      file: null,
      arrayEstoque: [],
    }),

    /* computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'ADICIONAR NOVO USUÁRIO' : 'EDITAR USUÁRIO'
      },
    }, */

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'ADICIONAR NOVO USUÁRIO' : 'EDITAR USUÁRIO'
      },
    }),

    watch: {
      configAccess (val) {
        if (val == true)
          this.openDialog()
      },
    },

    mounted() {
      //
    },

    methods: {
      carregaDados (params) {
        this.arrayEstoque = params
      },

      async enviaDados() {
        this.isLoading = true
        var vm = this;
        await axios.post(`${baseApiUrl}Estoques/salvarEstoque?access_token=${sessionStorage.getItem('accToken')}`, this.arrayEstoque)
        .then(response => {
          if (response.data == true) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#00253E","Operação realizada com sucesso!","white")
            this.planilhaParaJson = null
            this.planilhaSelecionada = null
            this.file = null
            this.arrayEstoque = []
          }
        }).catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#FEC8C8","Erro ao realizar operação","#BF4554")
        })
      },

      close () {
        this.addUser = false
        this.e1 = 1
        this.carregaDados()
        setTimeout(() => {
          this.questionario = Object.assign({}, this.defaultQuest)
          this.editedIndex = -1
        }, 300)
      },

      closeDialog() {
        this.dialog = false
        setTimeout(() => {
          this.pergunta = Object.assign({}, this.defaultPergunta)
          this.editedIndexPerg = -1
        }, 300)
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
    
  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }
</style>